// Payment terms describe calendar dates, not instants. The due date is inclusive.
const calendarDay = (value) => {
  if (!value) return null;
  const writtenDate =
    typeof value === "string" && value.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  const date = writtenDate
    ? new Date(
        Number(writtenDate[1]),
        Number(writtenDate[2]) - 1,
        Number(writtenDate[3])
      )
    : new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  return Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()) / 86400000;
};
export function daysPastDue(dueDate, now = new Date()) {
  const due = calendarDay(dueDate), today = calendarDay(now);
  return due === null || today === null ? 0 : Math.max(0, today - due);
}
export const isPastDue = (dueDate, now = new Date()) => daysPastDue(dueDate, now) > 0;

export function matchesDueDateRange(dueDate, range, now = new Date()) {
  if (range === "All dates") return true;
  const due = calendarDay(dueDate), today = calendarDay(now);
  if (due === null || today === null) return false;
  if (range === "Overdue") return due < today;
  const date = new Date(now);
  if (range === "Due this week") {
    const monday = today - ((date.getDay() + 6) % 7);
    return due >= monday && due <= monday + 6;
  }
  if (range === "Due this month") {
    const start = Date.UTC(date.getFullYear(), date.getMonth(), 1) / 86400000;
    const end = Date.UTC(date.getFullYear(), date.getMonth() + 1, 1) / 86400000;
    return due >= start && due < end;
  }
  if (range === "This quarter") {
    const start = Date.UTC(date.getFullYear(), Math.floor(date.getMonth() / 3) * 3, 1) / 86400000;
    return due >= start && due <= today;
  }
  return false;
}
